import React from 'react';
import CombinedEditableSection from '../../../../../../components/CombinedEditableSection.comp';
import {
  SlideDescription,
  SlideTitle,
  PointText,
} from '../../../../../styles/LearnTab/slideBase.styles';
import { SlideTitleHeader } from '../common/SlideTitleHeader.comp';
import { renderTextWithId } from '../common/EditableSlideField.comp';

export const LongTextSlide = ({
  slide,
  highlightWord,
  isEditMode = false,
  slideEdits = {},
  showEnglishContent = false,
  onSaveEdit,
  onResetEdit,
  onCancelEdit,
}) => {
  const textRendererOptions = { slideEdits, showEnglishContent, highlightWord };

  return (
    <SlideDescription>
      {isEditMode ? (
        <CombinedEditableSection
          slide={slide}
          isEditMode={isEditMode}
          slideEdits={slideEdits}
          showEnglishContent={showEnglishContent}
          onSave={onSaveEdit}
          onReset={onResetEdit}
          onCancel={onCancelEdit}
          TitleComponent={SlideTitle}
          ContentComponent={PointText}
        />
      ) : (
        <>
          <SlideTitleHeader
            slide={slide}
            slideEdits={slideEdits}
            showEnglishContent={showEnglishContent}
            highlightWord={highlightWord}
          />
          {renderTextWithId('content_0', slide?.SlideContent, PointText, {}, textRendererOptions)}
        </>
      )}
    </SlideDescription>
  );
};

export default LongTextSlide;
